<template>
  <v-container>
    <v-row>
      <v-col
        class="
          background-color-fire-engine-red-trans
          color-fire-engine-red
          text-center
        "
      >
        This item contains alcohol. You will be required to show ID to receive
        this item.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AlcoholProductsRequireIdWarning",
};
</script>
